<template>
  <VAvatar
    ref="baseAvatar"
    class="base-avatar"
    :color="placeholderBackgroundColor ?? defaultBackgroundColor"
    :size="size"
  >
    <slot name="default">
      <VImg
        :src="imgSrc"
        :alt="alt"
        cover
      >
        <template #placeholder>
          <div
            v-if="!useInitials"
            class="d-flex align-center justify-center fill-height"
          >
            <VIcon
              :color="iconColor"
              :icon="icon"
              :size="icon === '$twi-avatar' ? size: contentSize"
            />
          </div>
          <div
            v-else
            class="d-flex align-center justify-center fill-height prevent-select-text"
            data-testid="initials"
          >
            <span class="content-size">{{ initials }}</span>
          </div>
        </template>
      </VImg>
    </slot>
  </VAvatar>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const {
  alt = '',
  src = null,
  icon = '$twi-avatar',
  userName = '',
  useInitials = false,
  size = 40,
  placeholderBackgroundColor,
  iconColor = 'primary',
} = defineProps<{
  alt?: string;
  src: string | null | undefined;
  size?: number | string;
  icon?: string;
  userName?: string;
  placeholderBackgroundColor?: string;
  iconColor?: string;
  useInitials?: boolean;
}>();

const imgSrc = computed(() => src ?? undefined);

const defaultBackgroundColor = computed(() => {
  return imgSrc.value || (icon && !useInitials) ? 'white' : 'neutral-500';
});

const contentSize = computed(() => {
  const sizeInt = typeof size === 'string' ? parseInt(size) : size;
  return Math.round(sizeInt * 0.5);
});

const initials = computed(() => {
  return userName
    .split(' ')
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();
});
</script>

<style scoped lang="scss">
.content-size {
  font-size: v-bind('contentSize + "px"') !important;
}
</style>
